export default __webpack_public_path__ + "static/media/comp.88880b31.gif";